export default __webpack_public_path__ + "static/muktangan-7451c752c5ca85263f399c7d2075ac27.svg";